import { InvestAssetsQueryVariables } from 'src/common/apollo/types/swarm/graphql'
import { TokensQueryVariables } from 'src/common/apollo/types/swarmx/graphql'
import { AnyToken } from 'src/common/types/models/Tokens'
import { areAddressesEqual } from 'src/common/utils/web3/areAddressesEqual'
import { some, toLower, includes } from 'lodash'

export const getTokenFilter = (
  search?: string
): TokensQueryVariables['filter'] => {
  if (!search) return {}

  return {
    or: [{ address_contains_nocase: search }, { name_contains_nocase: search }],
  }
}

export const getInvestTokenFilter = (
  search?: string
): InvestAssetsQueryVariables['filter'] => {
  if (!search) return {}

  return {
    or: [{ symbol_contains_nocase: search }, { name_contains_nocase: search }],
  }
}

export const isSecurityToken = (token: AnyToken, investAssets: AnyToken[]) =>
  some(investAssets, investAsset =>
    areAddressesEqual(token.contractAddress, investAsset.contractAddress)
  )

export const isGoldToken = (token: AnyToken) =>
  token.name.toLowerCase().includes('xgold') ||
  token.name.toLowerCase().includes('xgold')

export const matchesSearch = (token: AnyToken, debouncedSearch: string) => {
  if (!debouncedSearch) return true
  const search = toLower(debouncedSearch)
  return (
    includes(toLower(token.name), search) ||
    includes(toLower(token.symbol), search)
  )
}
